import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const TruckEntrySvg = () => (
  <svg width="24" height="24" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 16C3.89543 16 3 15.1046 3 14C3 12.8954 3.89543 12 5 12C6.10457 12 7 12.8954 7 14C7 15.1046 6.10457 16 5 16Z" fill="currentColor" />
    <path
      d="M13.035 11.173C13.024 11.115 13 11.061 13 11V4C13 3.73478 13.1054 3.48043 13.2929 3.29289C13.4804 3.10536 13.7348 3 14 3H16C18.205 3
      20 4.794 20 7V13C20 13.2652 19.8946 13.5196 19.7071 13.7071C19.5196 13.8946 19.2652 14 19 14H17C17 12.344 15.656 11 14
      11C13.66 11 13.34 11.069 13.035 11.173ZM15 8H18V6H15V8Z"
      fill="currentColor"
    />
    <path d="M14 16C12.8954 16 12 15.1046 12 14C12 12.8954 12.8954 12 14 12C15.1046 12 16 12.8954 16 14C16 15.1046 15.1046 16 14 16Z" fill="currentColor" />
    <path
      d="M2 0H10C11.104 0 12 0.897 12 2V11.779C11.391 12.328 11 13.115 11 14H8C7.9798 13.2178 7.65487 12.4743 7.09446 11.9282C6.53405
      11.3821 5.7825 11.0765 5 11.0765C4.2175 11.0765 3.46595 11.3821 2.90554 11.9282C2.34513 12.4743 2.0202 13.2178 2 14H1C0.734783 14 0.480429
      13.8946 0.292892 13.7071C0.105356 13.5196 0 13.2652 0 13V2C0 0.897 0.896 0 2 0Z"
      fill="currentColor"
    />
  </svg>
);

const TruckEntry = (props: IIconProps) => <Icon component={TruckEntrySvg} {...props} />;

export default TruckEntry;
